import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { ArrayStringData } from '../../../utils';
import BaseFilter, { FilterTypeEnum } from '../../../components/base/BaseFilter';
import { connect, useSelector } from 'react-redux';
import { CampaignType, ApprovalStatus, RECORD_FILTER_REWARD_SCOPES } from 'config/CustomEnums';

function Filter({ campaignList, earningRuleList, transactionList, backAction = () => { } }) {
  const location = useLocation();
  const parsedSearch = queryString.parse(location.search);
  const searchRecordScope = parsedSearch['reward_scope'] || '';
  const searchEventType = parsedSearch['event_type'] || '';
  const searchRecordType = parsedSearch['record_type'] || '';
  const searchQuantity = parsedSearch['quantity'] || '';
  const searchCreationDate = parsedSearch['creation_date'] || '';
  const searchPurchaseDate = parsedSearch['purchase_date'] || '';
  const searchCampaigns = ArrayStringData(parsedSearch['campaigns'] || '');
  const searchEarningRules = ArrayStringData(
    parsedSearch['earning_rules'] || '',
  );
  const searchTransactions = ArrayStringData(
    parsedSearch['transaction'] || '',
  );

  const [recordScope, setRecordScope] = useState(ArrayStringData(searchRecordScope));
  const [eventType, setEventType] = useState(searchEventType);
  const [recordType, setRecordType] = useState(
    ArrayStringData(searchRecordType),
  );
  const [quantity, setQuantity] = useState(() => {
    const values = ArrayStringData(searchQuantity);
    if (values.length > 0) return values;
    return [0, 0];
  });
  const [creationDate, setCreationDate] = useState(searchCreationDate);
  const [purchaseDate, setPurchaseDate] = useState(searchPurchaseDate);
  const { maxQuantityValue } = useSelector((state) => ({
    maxQuantityValue: state.stampRecord.maxQuantityValue,
  }));
  const [targetCampaigns, setTargetCampaigns] = useState([]);
  const [targetEarningRules, setTargetEarningRules] = useState([]);
  const [targetTransaction, setTargetTransaction] = useState([]);

  useEffect(() => {
    if (searchCampaigns && campaignList) {
      let checkedCampaigns = [];
      searchCampaigns.forEach((item, index) => {
        const checkedSingeCampaign = campaignList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeCampaign) {
          checkedCampaigns.push({
            label: `[ID: ${checkedSingeCampaign?.pk}] ${checkedSingeCampaign?.name}`,
            value: checkedSingeCampaign,
          });
        }
      });
      setTargetCampaigns(checkedCampaigns);
    }
    if (searchEarningRules && earningRuleList) {
      let checkedEarningRules = [];
      searchEarningRules.forEach((item, index) => {
        const checkedSingeEarningRule = earningRuleList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeEarningRule) {
          checkedEarningRules.push({
            label: `[ID: ${checkedSingeEarningRule?.pk}] ${checkedSingeEarningRule?.name}`,
            value: checkedSingeEarningRule,
          });
        }
      });
      setTargetEarningRules(checkedEarningRules);
    }
    if (searchTransactions && transactionList) {
      let checkedTransactions = [];
      searchTransactions.forEach((item, index) => {
        const checkedSingeTransaction = transactionList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeTransaction) {
          checkedTransactions.push({
            label: `[ID: ${checkedSingeTransaction?.pk}] ${checkedSingeTransaction?.name}`,
            value: checkedSingeTransaction,
          });
        }
      });
      setTargetTransaction(checkedTransactions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const content = [
    {
      title: 'Reward scope',
      data: [
        {
          pk: RECORD_FILTER_REWARD_SCOPES.ALL_ISSUED,
          name: 'All issued',
        },
        {
          pk: RECORD_FILTER_REWARD_SCOPES.PARTIALLY_ISSUED,
          name: 'Partially issued',
        },
        {
          pk: RECORD_FILTER_REWARD_SCOPES.NONE_ISSUED,
          name: 'None issued',
        }
      ],
      value: recordScope,
      setValue: setRecordScope,
      component: FilterTypeEnum.choice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Event type',
      dislpayName: 'Event type',
      data: [
        { pk: 'ADD_STAMP', name: 'Add Stamp' },
        { pk: 'REMOVE_STAMP', name: 'Remove Stamp' },
      ],
      value: eventType,
      setValue: setEventType,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Record type',
      displayName: 'Record type',
      data: [
        { name: 'Customer earned', pk: 'CUSTOMER_EARN' },
        { name: 'Admin remove', pk: 'ADMIN_REMOVE' },
        { name: 'Admin add', pk: 'ADMIN_ADD' },
        { name: 'Merchant remove', pk: 'MERCHANT_REMOVE' },
        { name: 'Merchant add', pk: 'MERCHANT_ADD' },
        { name: 'Stamp expired', pk: 'STAMP_EXPIRED' },
        { name: 'Admin transferred', pk: 'ADMIN_TRANSFERRED' },
      ],
      value: recordType,
      setValue: setRecordType,
      component: FilterTypeEnum.choice,
    },
    {
      title: 'Purchase date',
      displayName: 'Purchase date',
      value: purchaseDate,
      setValue: setPurchaseDate,
      component: FilterTypeEnum.dateRange,
    },
    {
      title: 'Creation date',
      displayName: 'Creation date',
      value: creationDate,
      setValue: setCreationDate,
      component: FilterTypeEnum.dateRange,
    },
    {
      title: 'Quantity',
      displayName: 'Quantity',
      data: [0, maxQuantityValue],
      value: quantity,
      setValue: setQuantity,
      component: FilterTypeEnum.slider,
    },
    {
        filterTitle: 'Campaigns',
        data: campaignList,
        value: targetCampaigns,
        setValue: setTargetCampaigns,
        placeholder: 'Search by campaign ID and name',
        loadMoreAction: 'campaignList/getCampaignList',
        filterAction: 'campaignList/getCampaignList',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        defaultFilter: {
          isSimpleList: true,
          isAvailable: false,
          noLoading: true,
          searchNameOrId: true,
          status: ApprovalStatus.published,
          type: CampaignType.stampCampaign,
        },
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
      {
        filterTitle: 'Earning Rules',
        data: earningRuleList,
        value: targetEarningRules,
        setValue: setTargetEarningRules,
        placeholder: 'Search by earning rule ID and name',
        loadMoreAction: 'earningRuleList/getSimpleEarningRuleListForSelector',
        filterAction: 'earningRuleList/getSimpleEarningRuleListForSelector',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        defaultFilter: {
          isSelectorLoad: true,
          linkedCampaignType: CampaignType.stampCampaign,
        },
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
      {
        filterTitle: 'Transaction',
        data: transactionList,
        value: targetTransaction,
        setValue: setTargetTransaction,
        placeholder: 'Search by transaction ID',
        loadMoreAction: 'transactions/getSimpleTransactionsForSelector',
        filterAction: 'transactions/getSimpleTransactionsForSelector',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
  ];

  return (
    <BaseFilter
    content={content}
    backAction={backAction}
    />
  )
}
const mapPropsToState = (state) => ({
  campaignList: state.campaignList.allList,
  earningRuleList: state.earningRuleList.earningRuleList,
  transactionList: state.transactions.transactionList,
});


export default connect(mapPropsToState)(Filter);
